import * as React from "react";

interface Props {
  fieldLabels?: string[] | { label: string; span: number }[];
  className?: string;
  columnCount?: number;
}
export const ListFieldLabels: React.FC<Props> = ({ fieldLabels = [], className = "", columnCount }) => {
  if (fieldLabels.length < 1) {
    return null;
  }

  return (
    <div className={`field-labels w-full flex items-center gap-2 ${className}`}>
      <div className={`flex-grow grid grid-cols-${columnCount || fieldLabels.length} gap-2`}>
        {fieldLabels.length < 1 ? <div>Value</div> : null}
        {fieldLabels.map((field) => {
          const span = typeof field === "string" ? `col-span-1` : `col-span-${field.span}`;
          const value = typeof field === "string" ? field : field.label;

          return (
            <div className={`${span}`} key={value}>
              {value}
            </div>
          );
        })}
      </div>
      <div style={{ minWidth: 32, height: "100%" }} />
    </div>
  );
};
